import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const TMTIcon = createValidIcon((props) => {
  const { disabled, size = 40 } = props

  if (disabled) {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 40 40'
        fill='none'
      >
        <mask
          id='mask0_9815_7402'
          style={{ maskType: 'alpha' }}
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='40'
          height='40'
        >
          <path
            d='M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z'
            fill='black'
          />
        </mask>
        <g mask='url(#mask0_9815_7402)'>
          <rect width='40' height='40' fill='#252525' />
          <g filter='url(#filter0_f_9815_7402)'>
            <circle cx='4' cy='39' r='18' fill='#7F7F7F' />
          </g>
          <g filter='url(#filter1_f_9815_7402)'>
            <circle cx='36' cy='2' r='18' fill='url(#paint0_linear_9815_7402)' />
          </g>
        </g>
        <path
          d='M21.513 24.8487H17.5986C17.1236 24.8487 16.6844 24.5952 16.4468 24.1837L14.1975 20.2879C13.9599 19.8764 13.9599 19.3693 14.1975 18.9579L16.4468 15.0619C16.6844 14.6504 17.1236 14.3969 17.5986 14.3969H21.5112L24.6194 9.01319C24.5531 9.00829 24.4873 9 24.4201 9H15.2757C14.3097 9 13.4174 9.51533 12.9344 10.3518L8.36209 18.271C7.8793 19.1075 7.8793 20.1382 8.36209 20.9747L12.9344 28.8941C13.4174 29.7305 14.3098 30.2457 15.2757 30.2457H24.4201C24.4879 30.2457 24.5545 30.2374 24.6213 30.2324L21.5131 24.8488L21.513 24.8487Z'
          fill='white'
        />
        <path
          d='M31.3337 18.2711L26.7614 10.3517C26.7275 10.293 26.6872 10.2396 26.6491 10.1841L23.5409 15.5676L25.4983 18.9578C25.7358 19.3693 25.7358 19.8764 25.4983 20.2878L23.5418 23.6765L26.6502 29.0602C26.6877 29.005 26.7278 28.9523 26.7614 28.8939L31.3337 20.9747C31.8167 20.1383 31.8167 19.1076 31.3337 18.2711Z'
          fill='white'
        />
        <defs>
          <filter
            id='filter0_f_9815_7402'
            x='-27'
            y='8'
            width='62'
            height='62'
            filterUnits='userSpaceOnUse'
            colorInterpolationFilters='sRGB'
          >
            <feFlood floodOpacity='0' result='BackgroundImageFix' />
            <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
            <feGaussianBlur stdDeviation='6.5' result='effect1_foregroundBlur_9815_7402' />
          </filter>
          <filter
            id='filter1_f_9815_7402'
            x='1'
            y='-33'
            width='70'
            height='70'
            filterUnits='userSpaceOnUse'
            colorInterpolationFilters='sRGB'
          >
            <feFlood floodOpacity='0' result='BackgroundImageFix' />
            <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
            <feGaussianBlur stdDeviation='8.5' result='effect1_foregroundBlur_9815_7402' />
          </filter>
          <linearGradient
            id='paint0_linear_9815_7402'
            x1='33'
            y1='8'
            x2='20.5'
            y2='21.5'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#D1D1D1' />
            <stop offset='1' stopColor='#959595' />
          </linearGradient>
        </defs>
      </svg>
    )
  }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 40 40'
      fill='none'
    >
      <mask
        id='mask0_392_2846'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='40'
        height='40'
      >
        <path
          d='M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z'
          fill='black'
        />
      </mask>
      <g mask='url(#mask0_392_2846)'>
        <rect width='40' height='40' fill='#4B0E1C' />
        <g filter='url(#filter0_f_392_2846)'>
          <circle cx='4' cy='39' r='18' fill='#FB0042' />
        </g>
        <g filter='url(#filter1_f_392_2846)'>
          <circle cx='36' cy='2' r='18' fill='url(#paint0_linear_392_2846)' />
        </g>
      </g>
      <path
        d='M21.513 24.8487H17.5986C17.1236 24.8487 16.6844 24.5952 16.4468 24.1837L14.1975 20.2879C13.9599 19.8764 13.9599 19.3693 14.1975 18.9579L16.4468 15.0619C16.6844 14.6504 17.1236 14.3969 17.5986 14.3969H21.5112L24.6194 9.01319C24.5531 9.00829 24.4873 9 24.4201 9H15.2757C14.3097 9 13.4174 9.51533 12.9344 10.3518L8.36209 18.271C7.8793 19.1075 7.8793 20.1382 8.36209 20.9747L12.9344 28.8941C13.4174 29.7305 14.3098 30.2457 15.2757 30.2457H24.4201C24.4879 30.2457 24.5545 30.2374 24.6213 30.2324L21.5131 24.8488L21.513 24.8487Z'
        fill='#FFF6ED'
      />
      <path
        d='M31.3337 18.2711L26.7614 10.3517C26.7275 10.293 26.6872 10.2396 26.6491 10.1841L23.5409 15.5676L25.4983 18.9578C25.7358 19.3693 25.7358 19.8764 25.4983 20.2878L23.5418 23.6765L26.6502 29.0602C26.6877 29.005 26.7278 28.9523 26.7614 28.8939L31.3337 20.9747C31.8167 20.1383 31.8167 19.1076 31.3337 18.2711Z'
        fill='#FFF6ED'
      />
      <defs>
        <filter
          id='filter0_f_392_2846'
          x='-27'
          y='8'
          width='62'
          height='62'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='6.5' result='effect1_foregroundBlur_392_2846' />
        </filter>
        <filter
          id='filter1_f_392_2846'
          x='1'
          y='-33'
          width='70'
          height='70'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='8.5' result='effect1_foregroundBlur_392_2846' />
        </filter>
        <linearGradient
          id='paint0_linear_392_2846'
          x1='33'
          y1='8'
          x2='20.5'
          y2='21.5'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#28F27E' />
          <stop offset='1' stopColor='#178C49' stopOpacity='0.9' />
        </linearGradient>
      </defs>
    </svg>
  )
})
